// extracted by mini-css-extract-plugin
module.exports = {"header":"Z7whZ4_K","left":"k_NtXI1S","middle":"o5zXSJ6r","right":"vp01uWvY","board":"MmrJi5rs","busy":"dGocav9i"};